import { Component, inject, OnInit, ViewChild } from "@angular/core";

import { AgGridAngular, AgGridModule } from "@ag-grid-community/angular";
import { SubStrategyStats } from "../../models/Metric";
import { GridOptions } from "@ag-grid-community/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AuthService, UserSelectionService } from "@front/m19-services";
import { MatTabsModule } from "@angular/material/tabs";
import { untilDestroyed } from "@ngneat/until-destroy";
import { Currency } from "@front/m19-api-client";
import { TranslocoDirective } from "@jsverse/transloco";
import { MODAL_DATA, ModalRef } from "@front/m19-ui";

@Component({
  selector: "app-grid-viewer",
  standalone: true,
  templateUrl: "./grid-viewer.component.html",
  styleUrls: ["./grid-viewer.component.scss"],
  imports: [AgGridModule, MatTooltipModule, MatTabsModule, TranslocoDirective],
})
export class GridViewerComponent implements OnInit {
  private userSelectionService = inject(UserSelectionService);
  private authService = inject(AuthService);
  private data = inject<GridViewerModalData>(MODAL_DATA);
  modalRef = inject(ModalRef);

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  gridData: SubStrategyStats[] = this.data.gridData;
  gridOptions: GridOptions = this.data.gridOptions;

  currency?: Currency;
  locale?: string;

  ngOnInit(): void {
    this.userSelectionService.selectedCurrency$.pipe(untilDestroyed(this)).subscribe((currency) => {
      this.currency = currency;
    });
    this.authService.loggedUser$.pipe(untilDestroyed(this)).subscribe((user) => {
      this.locale = user.locale;
    });
  }

  close() {
    this.modalRef.close();
  }
}

export interface GridViewerModalData {
  gridData: SubStrategyStats[];
  gridOptions: GridOptions;
}
